var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCircle1 = function SvgCircle1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 764,
    height: 764,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#circle-1_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 382,
    r: 379.5,
    transform: "rotate(-90 382 382)",
    stroke: "url(#circle-1_svg__b)",
    strokeLinecap: "round",
    strokeDasharray: "4 6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "circle-1_svg__b",
    x1: 2,
    y1: 2,
    x2: 762,
    y2: 762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#fff",
    stopOpacity: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682,
    stopColor: "#fff",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807,
    stopColor: "#fff",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    stopColor: "#fff",
    stopOpacity: 0.37
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circle-1_svg__a",
    x: 0,
    y: 0,
    width: 764,
    height: 764,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_709_11734"
  })))));
};

export default SvgCircle1;